export enum DiaryCalendarView {
  Duodecennial = 1,
  Year = 2,
  Month = 3,
  Day = 4
}
